const assignBox = {
  form: {
    generalForm: {
      header: 'Driver Assignment Advanced Settings',
      actions: {
        saveCheckBox: 'Save as default',
      },
      formBtns: {
        btnCancel: 'Cancel',
        btnAssign: 'Assign',
      },
      inputAssignBy: 'Assignment Type',
      inputActualDrivers: 'Real',
      inputVirtualDrivers: 'Virtual',
    },
    actualForm: {
      information: {
        inputOnlyDrivers: 'Ignore Driver Shifts',
        inputMaxShiftsHours: 'Max Shifts Hours',
        defaultCarLocation: 'Default Car Location',
        inputMaxPrice: 'Max Price',
        inputFillVirtual: 'Fill unassigned with virtual drivers',
        inputMaxTrips: 'Max Trips',
        inputAssignFairly: 'Assign Fairly',
      },
      validations: {
        maxShifts: {
          require: 'Required',
          min: 'At least 1',
          max: 'Maxium 24',
        },
        carLocation: {
          require: 'Required',
        },
        fillVirtual: {
          require: 'Required',
        },
        maxTrips: {
          require: 'Required',
        },
        maxPrice: {
          require: 'Required',
        },
        default: {
          require: 'Required',
        },
      },
    },
    virtualForm: {
      information: {
        inputUpTo: 'Up to',
        inputDrivers: 'Drivers',
        inputMaxSeats: 'Max Seats',
        inputMaxShiftsHours: 'Max Shifts Hours',
        defaultCarLocation: 'Default Car Location',
        inputAssignFairly: 'Assign Fairly',
      },
      validations: {
        limitDrivers: {
          require: 'Required',
        },
        carLocation: {
          require: 'Required',
        },
        maxShifts: {
          require: 'Required',
          min: 'At least 1',
          max: 'Maxium 24',
        },
        default: {
          require: 'Required',
        },
      },
    },
    errorsMessages: {
      updateCar: 'Update car location failed',
    }
  },
};

export default assignBox;
